import { useEffect, useState, useRef } from "react";
import FormControl from "@mui/material/FormControl";
import Skeleton from "@mui/material/Skeleton";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

export default function Seletor({
  label,
  size,
  fullWidth,
  variant,
  value,
  list,
  variantTextField,
  className,
  setSelect = null,
  setSelectIdDesc = null,
  disabled,
  sx,
  isLoading = false,
  key,
  required,
  helperText,
  error,
}) {
  const [items, setItems] = useState(null);
  const [defaultItem, setDefaultItem] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (error && inputRef.current) {
      inputRef.current.focus();
    }
  }, [error]);

  const handleChange = (newValue) => {
    if (setSelectIdDesc) {
      if (newValue.hasOwnProperty("label"))
        setSelectIdDesc(newValue.id, newValue.label);
      else if (newValue.hasOwnProperty("descricao"))
        setSelectIdDesc(newValue.id, newValue.descricao);
      else setSelectIdDesc(newValue.id);
    }

    if (setSelect) {
      setSelect(newValue.id);
    }
  };

  const carregarDados = (dados, valor) => {
    let data = [];

    for (let i = 0; i < dados.length; i++) {
      const element = dados[i];

      element.descricao =
        element.descricao == null
          ? (element.descricao = "")
          : element.descricao;

      const newItem = {
        label: element.descricao,
        id: element.id,
      };

      data.push(newItem);

      if (valor > 0 && element.id === valor) {
        setDefaultItem(newItem);
      }
    }

    setItems(data);
  };

  useEffect(() => {
    carregarDados(list, value);
  }, [list]);


  return (
    <>
      <FormControl
        variant={variant}
        size="large"
        sx={sx}
        className={className}
        fullWidth={fullWidth}
        required={required}
        disabled={disabled}
      >
        {isLoading && (
          <Skeleton variant="wave" height={40} key={key} animation={false} />
        )}
        {!isLoading && !defaultItem && items?.length > 0 && (
          <Autocomplete
            disablePortal
            disabled={disabled}
            id={`id-${label}`}
            options={items}
            renderInput={(params) => (
              <TextField
                color="primary"
                inputRef={inputRef}
                error={error}
                helperText={helperText}
                required={required}
                {...params}
                label={label}
                variant={variantTextField}
              />
            )}
            onChange={(event, newValue) => handleChange(newValue)}
            size={size ?? "large"}
          />
        )}
        {!isLoading && defaultItem && (
          <Autocomplete
            id={`id-${label}`}
            options={items}
             disabled={disabled}
            renderInput={(params) => (
              <TextField
                inputRef={inputRef}
                color="primary"
                variant={variantTextField}
                error={error}
                helperText={helperText}
                {...params}
                required={required}
                label={label}
              
              />
            )}
            onChange={(event, newValue) => handleChange(newValue)}
            size={size ?? "large"}
            defaultValue={defaultItem}
          />
        )}
      </FormControl>
    </>
  );
}
